/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { Asset, AssetOption, Ducks, Percentage, PpvApi, PpvModule, ProductPrice } from '@wit/vtv-x-foundation-lib';
import { SagaIterator } from 'redux-saga';
import Options from 'core/store/ducks/pi/options';
import { call } from 'redux-saga/effects';

export default function* getPurchaseOptions(
  clones: Asset[],
  representativeVodsPrices: ProductPrice[],
  vat: Percentage
): SagaIterator<AssetOption[]> {
  try {
    const representativePpvModules: PpvModule[] = yield Ducks.Api.callApi(
      PpvApi.list,
      representativeVodsPrices.reduce((acc: string[], cur: ProductPrice) => {
        if (cur.ppvModuleId !== undefined) {
          return [...acc, cur.ppvModuleId.toString()];
        }

        return acc;
      }, [])
    );

    return yield call(Options.getPurchasesOptions, clones, representativeVodsPrices, representativePpvModules, vat);
  } catch (e) {
    return [];
  }
}
